import { OnboardingStepHeader } from "@/features/onboarding/components/onboarding-step-header";
import { ONBOARDING_FORM_STYLES } from "@/features/onboarding/components/onboarding-form-styles";
import React, { useEffect } from "react";
import JobPreferencesForm from "@/components/Forms/JobPreferencesForm";
import { ProviderOnboardingStep } from "@/features/onboarding/enums/ProviderOnboardingStep";
import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function JobPreferencesOnboardingStep({
  onComplete,
  onBack,
}: {
  onComplete: () => void;
  onBack?: () => void;
}) {
  const trpc = useTRPC();
  const { mutateAsync: updateOnboardingStep } = useMutation(
    trpc.providerOnboarding.updateProviderOnboardingStep.mutationOptions(),
  );

  const handleNext = async () => {
    await updateOnboardingStep({
      onboardingStepId: ProviderOnboardingStep.SHIFT_PREFERENCES,
    });
    onComplete();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className={ONBOARDING_FORM_STYLES.backButton}
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          Back
        </Button>
      )}
      <OnboardingStepHeader
        title="Job Preferences"
        description="Tell us what you're looking for so we can help you find jobs that fit. You can update these preferences anytime."
      />
      <JobPreferencesForm onComplete={handleNext} appearance="onboarding" />
    </div>
  );
}
